import React, { useEffect, useState } from "react";
import { CustomSelect, Creatable } from "../Shared/Select/Select";
import { useSelector, useDispatch } from "react-redux";
import isURL from "validator/lib/isURL";
import { getTypes } from "../../actions/sql/typeGroups";
import { fetchDcmLandingPages } from "../../actions/dcm/landingPages";
import { typeGroupNames, getSelectValue } from "../../utils/dataUtils";
import { addCustomLandingPage } from "../../actions/dcm/landingPages";
import { fetchUserAdvertisers } from "../../services/dcm/advertisers";

import {
  Grid,
  Typography,
  Button,
  TextField,
  makeStyles
} from "@material-ui/core";

import Label from "../Shared/Label";
import HelperTooltip from "../Shared/HelperTooltip/HelperTooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%"
  },
  paper: {
    padding: "20px",
    height: "100%"
  },
  gridSection: {
    margin: "0px 0 10px 0",
    "&:last-child": {
      margin: "20px 0 20px 0"
    }
  },
  textInput: {
    margin: 0,
    "& .MuiOutlinedInput-root.Mui-disabled": {
      "& fieldset": {
        borderColor: "rgba(230, 230, 230, 0.9)"
      }
    }
  },
  textInputDisabled: {
    backgroundColor: "rgba(242, 242, 242, 1)"
  },
  helperText: {
    margin: 0
  },
  buttonStyle: {
    marginRight: 12
  },
  typography: {
    marginLeft: 12,
    paddingBottom: 24,
    textAlign: "left",
    wordBreak: "break-all"
  },
  buttons: {
    marginLeft: "16px !important"
  }
}));

const CreativeNameGenerator = ({
  taxonomy,
  handleSelect,
  handleClearValues,
  handleSave,
  handleTextInput,
  isDisabled,
  errors,
  standalone,
  isDcmCreative,
  setAlert,
  fileDimensions,
  selectedCreative
}) => {
  let formGridSpacing = 3;
  let classes = useStyles();
  let dispatch = useDispatch();
  let typeGroupData = useSelector((state) => state.typeGroups);
  let landingPageData = useSelector((state) => state.dcmLandingPages);
  let [selectedTypeIds, setSelectedTypeIds] = useState({});
  let [userAdvertisers, setUserAdvertisers] = useState([]);
  const campaigns = useSelector((state) => state.dcmCampaigns);

  useEffect(() => {
    if (typeGroupData.allGroupNames.length === 0)
      dispatch(getTypes(typeGroupNames));
  }, [dispatch, typeGroupData.allGroupNames.length]);

  useEffect(() => {
    if (!campaigns.byId[campaigns.selectedId]) {
      fetchUserAdvertisers()
        .then((advertisersResponse) => setUserAdvertisers(advertisersResponse))
        .catch((err) => console.log(err));
    }
  }, []);

  useEffect(() => {
    if (
      !standalone &&
      landingPageData.allIds.length === 0 &&
      !landingPageData.isLoading && userAdvertisers != ""
    ) {
      let advertiserIds = [];
      if (!campaigns.byId[campaigns.selectedId]) {
        advertiserIds = userAdvertisers;
      } else {
        advertiserIds = [campaigns.byId[campaigns.selectedId].advertiserId];
      }
      dispatch(fetchDcmLandingPages(advertiserIds));
    }
  }, [dispatch, landingPageData, campaigns, standalone, userAdvertisers]);

  const setVisibleTypes = (option, action) => {
    let typeIds = { ...selectedTypeIds };
    if (option.id) {
      typeIds[action.name] = option.id;
    }
    setSelectedTypeIds(typeIds);
    handleSelect(option, action);
  };

  const showVisibleTypes = (typeData) => {
    if (typeData.length > 0) {
      if (typeData[0].parentTypeMatches.length > 0) {
        let filteredData = typeData.filter((type) => {
          let selectedIds = Object.values(selectedTypeIds);
          type.parentTypeMatches.map((parentId) =>
            selectedIds.includes(parentId)
          );
          return false;
        });

        if (filteredData.length === 0) return typeData;
      } else {
        return typeData;
      }
    }
  };

  const modelYearData = () => {
    let currentYear = new Date().getFullYear();
    return [
      { value: currentYear - 1, label: currentYear - 1 },
      { value: currentYear, label: currentYear },
      { value: currentYear + 1, label: currentYear + 1 },
      { value: currentYear + 2, label: currentYear + 2 }
    ];
  };

  const getURLData = (id) => {
    if (
      isDcmCreative &&
      selectedCreative.hasOwnProperty("clickTags") &&
      !selectedCreative.taxonomy.urlId
    ) {
      id = selectedCreative.clickTags[0].clickThroughUrl.landingPageId;
      return landingPageData.byId[id];
    } else if (id) {
      return landingPageData.byId[id];
    } else return "";
  };

  const nameGeneratorHeading = () => {
    let RMTypes = [
      "RICH_MEDIA_DISPLAY_BANNER",
      "RICH_MEDIA_DISPLAY_EXPANDING",
      "RICH_MEDIA_DISPLAY_INTERSTITIAL"
    ];

    let heading = "instructions here!!";
    if (isDcmCreative && isDcmCreative.hasOwnProperty("clickTags")) {
      heading =
        "Note: A URL does not need to be selected for existing H5 creatives. If there is a URL change, please select a URL from the dropdown or add a new URL.";
    } else if (isDcmCreative && RMTypes.includes(isDcmCreative.type)) {
      heading = "Note: A URL does not need to be selected for existing Rich Media creatives. If there is a URL change, please select a URL from the dropdown or add a new URL.";
    }
    else if (taxonomy.name) {
      heading = "";
    } else if (standalone) {
      heading = "Add and select a new name on left before generating name";
    } else {
      heading = "Select a creative from left before generating name";
    }
    return heading;
  };

  const handleCreateUrl = (inputValue) => {
    let action = { name: "urlId" };
    //add URL validation here

    if (isURL(inputValue)) {
      let { landingPage } = dispatch(addCustomLandingPage(inputValue));
      handleSelect(landingPage, action);
    } else {
      //throw error alert
      setAlert("Not a valid URL. Please be sure to include http(s).");
    }
  };

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item>
          <Typography variant="body1" className={classes.typography}>
            {nameGeneratorHeading()}
          </Typography>
        </Grid>
        <Grid
          classes={{ container: classes.gridSection }}
          item
          container
          spacing={formGridSpacing}
        >
          {standalone ? null : (
            <Grid item lg={12} xs={12} style={{ paddingTop: 0 }}>
              <Label>
                URL (the URL will be applied to all the creatives highlighted in
                blue)
              </Label>
              <CustomSelect
                name="urlId"
                isDisabled={typeGroupData.isLoading || isDisabled}
                value={getURLData(taxonomy.urlId)}
                getOptionLabel={(option) => option.url}
                getOptionValue={(option) => option.id}
                // getNewOptionData={(inputValue, optionLabel) => ({
                //   url: optionLabel,
                //   id: inputValue,
                //   __isNew__: true
                // })}
                onChange={setVisibleTypes}
                // onCreateOption={handleCreateUrl}
                options={Object.values(landingPageData.byId)}
                error={errors.urlId.isError}
              />
            </Grid>
          )}

          {!isDcmCreative && (
            <>
              <Grid item lg={6} xs={12}>
                <Label>Make</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="make"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Make"].types,
                    taxonomy.make
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Make"].types}
                  error={errors.make.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Model Year</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="modelYear"
                  value={getSelectValue(modelYearData(), taxonomy.modelYear)}
                  onChange={setVisibleTypes}
                  options={modelYearData()}
                  error={errors.modelYear.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Model</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="model"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Model"].types,
                    taxonomy.model
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={showVisibleTypes(
                    typeGroupData.byGroupName["Model"].types
                  )}
                  error={errors.model.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>
                  Trim
                  <HelperTooltip tooltipText="If field does not apply, please leave blank." />
                </Label>
                <TextField
                  classes={{ root: classes.textInput }}
                  variant="outlined"
                  margin="dense"
                  hiddenLabel
                  name="trim"
                  onChange={handleTextInput}
                  value={taxonomy.trim || ""}
                  disabled={typeGroupData.isLoading || isDisabled}
                  error={errors.trim.isError}
                  helperText={errors.trim.message}
                  fullWidth
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Creative Agency</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="creativeAgency"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Creative Agency"].types,
                    taxonomy.creativeAgency
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Creative Agency"].types}
                  error={errors.creativeAgency.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Strategy</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="strategy"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Strategy"].types,
                    taxonomy.strategy
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Strategy"].types}
                  error={errors.strategy.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Retail Offer Type</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="retailOfferType"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Retail Offer Type"].types,
                    taxonomy.retailOfferType
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Retail Offer Type"].types}
                  error={errors.retailOfferType.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Creative Unit</Label>
                <TextField
                  classes={{ root: classes.textInput }}
                  variant="outlined"
                  margin="dense"
                  hiddenLabel
                  name="creativeUnit"
                  onChange={handleTextInput}
                  value={taxonomy.creativeUnit || ""}
                  disabled={typeGroupData.isLoading || isDisabled}
                  error={errors.creativeUnit.isError}
                  helperText={errors.creativeUnit.message}
                  fullWidth
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>
                  Event/Offer/Promotion/Ad ID
                  <HelperTooltip tooltipText="Please indicate the expiration of retail offers (non-feed dynamic creative) in the Event/Offer/Promotion/Ad ID field. If field does not apply, please leave blank. For more information, please visit the Help page." />
                </Label>
                <TextField
                  classes={{ root: classes.textInput }}
                  variant="outlined"
                  margin="dense"
                  hiddenLabel
                  name="extraInfo"
                  onChange={handleTextInput}
                  value={taxonomy.extraInfo || ""}
                  disabled={typeGroupData.isLoading || isDisabled}
                  error={errors.extraInfo.isError}
                  helperText={errors.extraInfo.message}
                  fullWidth
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Format</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="format"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Format"].types,
                    taxonomy.format
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Format"].types}
                  error={errors.format.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Country</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="country"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Country"].types,
                    taxonomy.country
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Country"].types}
                  error={errors.country.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Language</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="language"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Language"].types,
                    taxonomy.language
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Language"].types}
                  error={errors.language.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Creative Version</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="creativeVersion"
                  onChange={setVisibleTypes}
                  value={getSelectValue(
                    typeGroupData.byGroupName["Creative Version"].types,
                    taxonomy.creativeVersion
                  )}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Creative Version"].types}
                  error={errors.creativeVersion.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Dimensions</Label>
                <CustomSelect
                  isDisabled={
                    typeGroupData.isLoading || isDisabled || fileDimensions
                  }
                  name="dimensions"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Dimensions"].types,
                    !taxonomy.dimensions && fileDimensions
                      ? fileDimensions
                      : taxonomy.dimensions
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Dimensions"].types}
                  error={errors.dimensions.isError}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Label>Creative Display</Label>
                <CustomSelect
                  isDisabled={typeGroupData.isLoading || isDisabled}
                  name="creativeDisplay"
                  value={getSelectValue(
                    typeGroupData.byGroupName["Creative Display"].types,
                    taxonomy.creativeDisplay
                  )}
                  onChange={setVisibleTypes}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.value}
                  options={typeGroupData.byGroupName["Creative Display"].types}
                  error={errors.creativeDisplay.isError}
                />
              </Grid>
              <Grid item lg={12} xs={12}>
                <Label>Notes (optional)</Label>
                <TextField
                  classes={{ root: classes.textInput }}
                  variant="outlined"
                  margin="dense"
                  hiddenLabel
                  name="notes"
                  onChange={handleTextInput}
                  value={taxonomy.notes || ""}
                  disabled={typeGroupData.isLoading || isDisabled}
                  fullWidth
                  multiline
                  rows="4"
                />
              </Grid>
            </>
          )}
        </Grid>
        <Grid
          classes={{ container: classes.gridSection }}
          item
          container
          justify="flex-start"
          className={classes.buttons}
        >
          <Grid item>
            <Button
              disabled={isDisabled}
              variant="contained"
              onClick={handleSave}
              className={classes.buttonStyle}
              color="secondary"
              disableElevation
            >
              {isDcmCreative ? "Save URL" : "Save Name"}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              onClick={handleClearValues}
              className={classes.buttonStyle}
              disableElevation
            >
              Clear Values
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

CreativeNameGenerator.defaultProps = {
  creative: {
    taxonomy: {
      name: "default»creative»name»taxonomy»and»things"
    }
  }
};

export default CreativeNameGenerator;
